import { AppRoutes } from '../routes/routes';
import { Permission } from '../../core/models/users.model';

type SidebarViewMode = 'location' | 'admin' | 'both';

interface SidebarItem {
  tittle: string;
  showAsTab: boolean;
  separateRoute: boolean;
  menu: SidebarMenuItem[];
}

interface SidebarMenuItem {
  menuValue: string;
  hasSubRoute?: boolean;
  showSubRoute?: boolean;
  base?: string;
  route?: string;
  icon?: string;
  permision?: Permission;
  featureFlag?: string;
  show_nav?: boolean;
  viewMode?: SidebarViewMode;
  subMenus?: SidebarMenuItem[];
  img?: string;
}

export const sidebar: SidebarItem[] = [
  {
    tittle: 'Main',
    showAsTab: false,
    separateRoute: false,
    menu: [
      {
        menuValue: 'Home',
        hasSubRoute: false,
        showSubRoute: false,
        base: AppRoutes.dashboard.dashboardUnique,
        route: AppRoutes.dashboard.dashboardUnique,
        img: 'assets/img/icons/menu-icon-01.svg',
        viewMode: 'admin',
      },
      {
        menuValue: 'Users',
        hasSubRoute: false,
        showSubRoute: false,
        base: AppRoutes.doctors.users,
        route: AppRoutes.doctors.users,
        img: 'assets/img/icons/menu-icon-02.svg',
        permision: 'view_employees',
        viewMode: 'admin',
      },
      {
        menuValue: 'Home',
        hasSubRoute: false,
        showSubRoute: false,
        base: AppRoutes.dashboard.dashboardUnique,
        route: AppRoutes.dashboard.dashboardUnique,
        img: 'assets/img/icons/menu-icon-01.svg',
        viewMode: 'location',
      },
      {
        menuValue: 'Employees',
        hasSubRoute: false,
        showSubRoute: false,
        base: AppRoutes.doctors.doctors,
        route: AppRoutes.doctors.list,
        img: 'assets/img/icons/menu-icon-02.svg',
        permision: 'manage_employees',
      },
      {
        menuValue: 'Clients',
        hasSubRoute: false,
        showSubRoute: false,
        base: AppRoutes.patients.patients,
        route: AppRoutes.patients.list,
        img: 'assets/img/icons/menu-icon-03.svg',
      },
      {
        menuValue: 'Parents',
        hasSubRoute: false,
        showSubRoute: false,
        base: AppRoutes.parents.parents,
        route: AppRoutes.parents.list,
        img: 'assets/img/icons/menu-icon-08.svg',
        permision: 'view_parents',
      },
      {
        menuValue: 'Notes',
        hasSubRoute: false,
        showSubRoute: false,
        base: AppRoutes.notes.view,
        route: AppRoutes.notes.view,
        show_nav: true,
        img: 'assets/img/icons/menu-icon-15.svg',
        permision: 'view_notes',
      },
      // {
      //   menuValue: 'Init. Assess.',
      //   hasSubRoute: false,
      //   showSubRoute: false,
      //   base: 'medical',
      //   route: AppRoutes.initialAssessment.initialAssessment,
      //   img: 'assets/img/icons/menu-icon-12.svg',
      //   permision: 'view_bips',
      //   show_nav: true,
      // },
      {
        menuValue: 'Calendar',
        hasSubRoute: false,
        showSubRoute: false,
        base: AppRoutes.calendar.calendar,
        route: AppRoutes.calendar.view,
        show_nav: true,
        img: 'assets/img/icons/menu-icon-04.svg',
        permision: 'view_notes',
      },
      {
        menuValue: 'Insurance',
        hasSubRoute: false,
        showSubRoute: false,
        base: AppRoutes.insurance.insurance,
        route: AppRoutes.insurance.list,
        img: 'assets/img/icons/menu-icon-09.svg',
        permision: 'manage_insurances',
        viewMode: 'both',
      },
      {
        menuValue: 'Locations',
        hasSubRoute: false,
        showSubRoute: false,
        base: AppRoutes.location.location,
        route: AppRoutes.location.list,
        img: 'assets/img/icons/menu-icon-06.svg',
        permision: 'manage_locations_access',
        viewMode: 'admin',
      },
      {
        menuValue: 'Loc. Settings',
        hasSubRoute: false,
        showSubRoute: false,
        base: AppRoutes.location.location,
        route: AppRoutes.location.edit,
        img: 'assets/img/icons/menu-icon-06.svg',
        permision: 'update_own_location',
        viewMode: 'location',
      },
      {
        menuValue: 'Reports',
        hasSubRoute: false,
        showSubRoute: false,
        base: AppRoutes.reports.access,
        route: AppRoutes.reports.access,
        img: 'assets/img/icons/menu-icon-13.svg',
        viewMode: 'location'
      },
      {
        menuValue: 'Reports',
        hasSubRoute: false,
        showSubRoute: false,
        base: AppRoutes.reports.accessAdmin,
        route: AppRoutes.reports.accessAdmin,
        img: 'assets/img/icons/menu-icon-13.svg',
        viewMode: 'admin'
      },
      {
        menuValue: 'Tickets',
        hasSubRoute: false,
        showSubRoute: false,
        base: AppRoutes.tickets.tickets,
        route: AppRoutes.tickets.list,
        img: 'assets/img/icons/menu-icon-10.svg',
        permision: 'manage_tickets',
        viewMode: 'admin',
      },
      {
        menuValue: 'Roles',
        hasSubRoute: false,
        showSubRoute: false,
        base: AppRoutes.locationRoles.locationRoles,
        route: AppRoutes.locationRoles.list,
        icon: 'fa-users-gear',
        img: 'assets/img/icons/draft.svg',
        permision: 'manage_roles',
      },
      {
        menuValue: 'Administration',
        hasSubRoute: false,
        showSubRoute: false,
        base: AppRoutes.settings.settings,
        route: AppRoutes.settings.settings,
        icon: 'fa-cog',
        img: 'assets/img/icons/menu-icon-16.svg',
        permision: 'use_admin_tools',
        viewMode: 'admin',
      },
    ],
  },
];
